import { paths } from "@/shared/refs/paths";
import type { ISOString } from "@/shared/typings/types/utils";
import { AccountConnection, Box, Button, Layout, Text } from '@shopify/polaris';
import { DateTime } from 'luxon';
import { getAppSubscription } from "redux/slices/app";
import { getRequestShop } from "redux/slices/env";
import { useAppSelector } from "../../redux/hooks";

type DateValType = ISOString | { toMillis: () => number } | undefined | null;

export default function Plan() {
  const shop = useAppSelector(getRequestShop);
  const appHandle = import.meta.env.VITE_APP_HANDLE || "shop-handbook";
  const managePlanUrl = paths.appPlanSelectionPage(appHandle, shop);

  const subscription = useAppSelector(getAppSubscription);
  const { appPlanName, appPlanDate } = subscription || {};

  const formatDate = (dateVal: DateValType): string => {
    if (!dateVal) return "";
    try {
      if (typeof dateVal === 'object' && 'toMillis' in dateVal) {
        return DateTime.fromMillis(dateVal.toMillis()).toLocaleString(DateTime.DATE_MED);
      }
      return DateTime.fromISO(dateVal as string).toLocaleString(DateTime.DATE_MED);
    } catch (e) {
      return String(dateVal);
    }
  };

  return (
    <Layout.AnnotatedSection
      title="Plan"
      description="Manage your plan and compare the features."
    >
      <AccountConnection
        title={subscription?.appPlanName || ""}
        action={{
          content: "Manage",
          url: managePlanUrl,
          target: "_parent",
        }}
        details={subscription?.appPlanName
          ? (
            <Text as="span">
              Current Plan Since{" "}
              <Text as="span" fontWeight="medium">
                {formatDate(appPlanDate)}
              </Text>
            </Text>
          ) : (
            <Text as="span">No Plan</Text>
          )
        }
        termsOfService={
          <Box>
            Understanding{" "}
            <Button
              url="https://automatecommerce.zendesk.com/hc/en-us/articles/12483112806287-Understanding-subscription-charges-and-uninstalling"
              variant="plain"
              target="_top"
            >
              subscription charges and uninstalling
            </Button>
          </Box>
        }
      />
    </Layout.AnnotatedSection>
  );
}
